export const FETCH_SENT_MESSAGE_ERROR = 'SENT_MESSAGE/FETCH_SENT_MESSAGE_ERROR' as const;
export const FETCH_SENT_MESSAGE_REQUEST = 'SENT_MESSAGE/FETCH_SENT_MESSAGE_REQUEST' as const;
export const FETCH_SENT_MESSAGE_RESPONSE = 'SENT_MESSAGE/FETCH_SENT_MESSAGE_RESPONSE' as const;
export const RESEND_MESSAGE_REQUEST = 'SENT_MESSAGE/RESEND_MESSAGE_REQUEST' as const;
